<template lang="pug">
  section.singlePhotos(v-if='listing && listing.Content')
    .singlePhotos-mainPhoto(v-if='listing.Content.FullPageImage2')
      img(:src='$hostname + listing.Content.FullPageImage2.formats.medium.url')
      .slider-toggle(
        @click='$emit("enableSlider")',
      ) <span>see all photos</span>
        SvgComponent.singleIntro-expand(name='expand')      
      

    .singlePhotos-photogrid
      .singlePhotos-photo(v-for='photo in gridPhotos', :key='photo.id')
        img(:src='$hostname + photo.formats.medium.url')

</template>

<script>
  import SvgComponent from '@/components/SvgComponent';


  export default {
    components: {
      SvgComponent,
    },
    props: ['listing'],
    methods:{
     
    },
    computed: {
      gridPhotos() {
        return this.listing?.Content?.SliderImages?.slice(0, 4) || [];
      }
    },
    mounted() {
      console.log('SingleFeatures mounted', this.$props);
      console.log('listing123', this.gridPhotos);
      // console.log('listing123', this.listing.Content);
    },
  };
</script>

<style lang="scss">
  .singlePhotos{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    /* min-height: 458px; */

    @include phone {
      grid-template-columns: 1fr;
      gap: 12px;
    }

    &-mainPhoto {
      width: 100%;
      overflow: hidden;
      position: relative;
      &:hover {
        img {
          transform: scale(1.1);
          transition: transform 0.2s ease-in;
        }
      }      
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.2s ease-out;
      }
      .slider-toggle {
        position: absolute;
        bottom: 40px;
        right: 40px;
        color: white;
        font-size: 17px;
        font-weight: 700;
        display: flex;
        align-items: center;
        gap: 12px;
        cursor: pointer;
        @include phone {
          bottom: 16px;
          right: 16px;
        }
      }
    }
    &-photogrid {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 20px;    
      
      @include phone {
        gap: 12px;
      }
    }
    &-photo {
      width: 100%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.2s ease-out;
      }

      &:hover {
        img {
          transform: scale(1.1);
          transition: transform 0.2s ease-in;
        }
      }
    }

  }
</style>
